export interface ENV {
  API_KEY_ENDPOINT: string;
  API_ENDPOINT: string;
  PAYMENT_ENDPOINT: string;
  CLIENT_ID_GOOGLE: string;
  MEDIA_ENDPOINT: string;
  SIGNALR_ENDPOINT: string;
  CLIENT_ID_PAYPAL: string;
  CLIENT_ENDPOINT: string;
  KEY_BASE: string;
}

export const envConfig: ENV = {
  API_KEY_ENDPOINT: process.env.REACT_APP_APIKEY_ENDPOINT ?? "",
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT ?? "",
  PAYMENT_ENDPOINT: process.env.REACT_APP_PAYMENT_API_ENDPOINT ?? "",
  CLIENT_ID_GOOGLE: process.env.REACT_APP_CLIENT_ID_GOOGLE ?? "",
  MEDIA_ENDPOINT: process.env.REACT_APP_MEDIA_API_ENDPOINT ?? "",
  SIGNALR_ENDPOINT: process.env.REACT_APP_SIGNALR_ENDPOINT ?? "",
  CLIENT_ID_PAYPAL: process.env.REACT_APP_CLIENT_ID_PAYPAL_ENDPOINT ?? "",
  CLIENT_ENDPOINT: process.env.REACT_APP_CLIENT_ENDPOINT ?? "",
  KEY_BASE: process.env.REACT_APP_KEY_BASE ?? "",
};
